module.exports = __webpack_public_path__ + "img/Vivienda-Incendio-1r.94876bf0.png";